export default [
  {
    id: '91973108-1235-4744-b502-0f2613487da8', // id 全局唯一，终身制
    path: '/wiz-iot-management-tongre',
    name: 'wizIotManagementTongre',
    meta: { title: '物联网系统' },
    // layout: 'default',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: '202f1bb4-62cb-42c7-ade2-124ff2967116', // id 全局唯一，终身制
        path: 'basic-setting',
        name: 'basicSetting',
        meta: { title: '基础设置' },
        children: [
          {
            id: 'ceafb818-6693-4ab0-8dd4-7176f935d744',
            path: 'access-template',
            name: 'accessTemplate',
            component: () => {
              return import('./views/basic-setting/access-template/index')
            },
            meta: {
              title: '接入模板管理',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: 'a32a97d0-57bf-45c2-9876-013eb4d622c6', // id 全局唯一，终身制
        path: 'monitor-manage',
        name: 'monitorManage',
        meta: { title: '摄像头管理' },
        children: [
          {
            id: '054f8ceb-923a-4406-a549-eacc35f58e8a',
            path: 'monitor-protocol',
            name: 'monitorProtocol',
            component: () => {
              return import('./views/monitor-manage/monitor-protocol/index')
            },
            meta: {
              title: '摄像头协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '3fde83c6-9403-4fd5-bc77-e5c28244a884',
            path: 'monitor-linkin',
            name: 'monitorLinkin',
            component: () => {
              return import('./views/monitor-manage/monitor-linkin/index')
            },
            meta: {
              title: '摄像头接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '47183ddc-4ffe-408c-813d-3442777d0fa3',
            path: 'monitorList',
            name: 'monitorList',
            component: () => {
              return import('./views/monitor-manage/monitor-list/index')
            },
            meta: {
              title: '摄像头清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '4e31ed0e-ba77-472f-a733-ba1705ecc18a',
            path: 'real-time-monitor',
            name: 'realTimeMonitor',
            component: () => {
              return import('./views/monitor-manage/real-time-monitor/index')
            },
            meta: {
              title: '实时监控',
            },
          },
          {
            id: '280e0960-6dee-4e31-bcce-a7143d83ae8e',
            path: 'cameraLocation',
            name: 'cameraLocation',
            component: () => {
              return import('./views/monitor-manage/monitor-location-setting/index')
            },
            meta: {
              title: '设备位置设置',
              hidden: true,
              tabnab: false,
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: 'e775313c-62b3-474e-9d43-0e7aa29d2349', // id 全局唯一，终身制
        path: 'access-control-manage',
        name: 'accessControlManage',
        meta: { title: '门禁管理' },
        children: [
          {
            id: 'b6342e37-b8c4-4763-8a0b-70ede9672a44',
            path: 'access-control-protocol',
            name: 'accessControlProtocol',
            component: () => {
              return import('./views/access-control-manage/access-control-protocol/index')
            },
            meta: {
              title: '门禁协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'f457af64-af33-423f-b0dd-8a591be3db09',
            path: 'access-control-linkin',
            name: 'accessControlLinkin',
            component: () => {
              return import('./views/access-control-manage/access-control-linkin/index')
            },
            meta: {
              title: '门禁接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'ca835663-3316-412f-936f-db0133255fa3',
            path: 'access-control-list',
            name: 'accessControlList',
            component: () => {
              return import('./views/access-control-manage/access-control-list/index')
            },
            meta: {
              title: '门禁清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '7fd58e7d-eddf-4e62-a252-b7464548d3f5',
            path: 'access-control-redord',
            name: 'accessControlRecord',
            component: () => {
              return import('./views/access-control-manage/access-control-record/index')
            },
            meta: {
              title: '人员出入记录',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '62fd8610-4734-4c4c-a423-3e18866e542c',
            path: 'person-statistics-panel',
            name: 'personStatisticsPanel',
            component: () => {
              return import('./views/access-control-manage/person-statistics-panel/index')
            },
            meta: {
              title: '人员统计面板',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '75e6574f-bba1-46fe-96c6-5cb84bba1855', // id 全局唯一，终身制
        path: 'barrier-gate-manage',
        name: 'barrierGateManage',
        meta: { title: '道闸管理' },
        children: [
          {
            id: '836b1697-dd43-4cf7-867f-4519c5b030e8',
            path: 'barrier-gate-protocol',
            name: 'barrierGateProtocol',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-protocol/index')
            },
            meta: {
              title: '道闸协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '2d565ea5-f396-44ff-80cb-9dd6c392e767',
            path: 'barrier-gate-linkin',
            name: 'barrierGateLinkin',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-linkin/index')
            },
            meta: {
              title: '道闸接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '5f1dab8a-ad98-43fc-9791-b9cecbe43be0',
            path: 'barrier-gate-list',
            name: 'barrierGateList',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-list/index')
            },
            meta: {
              title: '道闸清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'a17b2bd3-d1c0-45a0-9c5e-2429db9e71e6',
            path: 'barrier-gate-redord',
            name: 'barrierGateRecord',
            component: () => {
              return import('./views/barrier-gate-manage/barrier-gate-record/index')
            },
            meta: {
              title: '车辆出入记录',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '13260f57-927d-4870-a770-1af3656d872f', // id 全局唯一，终身制
        path: 'broadcast-manage',
        name: 'broadcastManage',
        meta: { title: '广播管理' },
        children: [
          {
            id: 'fd002fd4-6ec5-4cf9-ac32-5a867c04be23',
            path: 'broadcast-protocol',
            name: 'broadcastProtocol',
            component: () => {
              return import('./views/broadcast-manage/broadcast-protocol/index')
            },
            meta: {
              title: '广播协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '69d12e5a-a050-427e-bf33-c17422b3dde6',
            path: 'broadcast-linkin',
            name: 'broadcastLinkin',
            component: () => {
              return import('./views/broadcast-manage/broadcast-linkin/index')
            },
            meta: {
              title: '广播接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '3a00d3e7-d58d-4d29-9a8a-ab1b4836f4f4',
            path: 'broadcast-list',
            name: 'broadcastList',
            component: () => {
              return import('./views/broadcast-manage/broadcast-list/index')
            },
            meta: {
              title: '广播清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'c3c47fc0-1b32-4430-9a8f-616a08f6d5d5',
            path: 'broadcast-apply',
            name: 'broadcastApply',
            component: () => {
              return import('./views/broadcast-manage/broadcast-apply/index')
            },
            meta: {
              title: '在线广播',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
      {
        id: '19b8360b-468d-4c06-b31d-79cc38006554', // id 全局唯一，终身制
        path: 'fire-fighting-manage',
        name: 'fireFightingManage',
        meta: { title: '消防设备管理' },
        children: [
          {
            id: 'f7d7a452-2bd5-4495-8fec-33b575927197',
            path: 'fire-fighting-protocol',
            name: 'fireFightingProtocol',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-protocol/index')
            },
            meta: {
              title: '消防设备协议',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '0a719a67-7523-466b-ba66-f8a86c0ab23a',
            path: 'fire-fighting-linkin',
            name: 'fireFightingLinkin',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-linkin/index')
            },
            meta: {
              title: '消防设备接入',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: 'cd87d5a7-551d-4fdb-b5d3-efe0d4dae9b5',
            path: 'fire-fighting-list',
            name: 'fireFightingList',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-list/index')
            },
            meta: {
              title: '消防设备清单',
              operations: {
                create: {
                  id: 0,
                  name: 'create',
                  desc: '新增',
                  access: true,
                },
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                update: {
                  id: 2,
                  name: 'update',
                  desc: '修改',
                  access: true,
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
          {
            id: '30b3ce7f-fa8f-4cf2-b51b-ba592412bba6',
            path: 'fire-fighting-message',
            name: 'fireFightingMessage',
            component: () => {
              return import('./views/fire-fighting-manage/fire-fighting-message/index')
            },
            meta: {
              title: '消防设备消息',
              operations: {
                read: {
                  id: 1,
                  name: 'read',
                  desc: '详情',
                  access: true,
                  group: 'read',
                },
                delete: {
                  id: 3,
                  name: 'delete',
                  desc: '删除',
                  access: true,
                },
              },
            },
          },
        ],
      },
    ],
  },
]
